import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { T, t } from '@sm/intl';
import { createUseStyles } from 'react-jss';
import { Box } from '@wds/box';
import { Button } from '@wds/button';
import { Typography } from '@wds/typography';
import { IconInfo } from '@wds/icons';
export const COPY = {
  createTwoThemes: {
    id: 'OpenEndedCoding.GuidanceBanner.createTwoThemes',
    defaultMessage: 'Create at least 2 themes to go to the next step of the auto-tagging process. You can also tag responses manually.',
    description: '[Type: Header][Vis: med] - Banner to alert user to add more themes'
  },
  iconInfo: {
    id: 'OpenEndedCoding.GuidanceBannerIconInfo',
    defaultMessage: 'Info icon',
    description: '[Type: Label][Vis: low] - Info icon'
  },
  newThemes: {
    id: 'OpenEndedCoding.GuidanceBanner.newThemes',
    defaultMessage: "You've changed your themes. Update auto-tagging to apply them to your responses.",
    description: '[Type: Header][Vis: med] - Banner to alert user to re run auto-tagging'
  },
  updateButton: {
    id: 'OpenEndedCoding.GuidanceBanner.updateButton',
    defaultMessage: 'Update auto-tagging',
    description: '[Type: Header][Vis: med] - Button to trigger auto-tagging model'
  }
};
const useStyles = createUseStyles(theme => ({
  banner: {
    background: theme.palette.background.info.light,
    [`@media (min-width: ${theme.breakpoints.lg}px)`]: {
      marginLeft: `${theme.spacing[9]}px`,
      marginRight: `${theme.spacing[8]}px`
    }
  }
}));
const GuidanceBanner = ({
  variant = 'default',
  handleClickUpdateButton,
  hasInsufficientThemes
}) => {
  const {
    banner
  } = useStyles();
  return _jsxs(Box, {
    className: banner,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    my: 3,
    py: 3,
    children: [_jsxs(Box, {
      display: "flex",
      children: [_jsx(Box, {
        ml: 5,
        mr: 3,
        children: _jsx(IconInfo, {
          title: t(COPY.iconInfo),
          color: "info",
          size: "md"
        })
      }), _jsx(Typography, {
        children: _jsx(T, {
          desc: variant === 'update' && !hasInsufficientThemes ? COPY.newThemes : COPY.createTwoThemes
        })
      })]
    }), _jsx(Box, {
      mr: 3,
      children: variant == 'update' && _jsx(Button, {
        color: "info",
        onClick: handleClickUpdateButton,
        disabled: hasInsufficientThemes,
        children: _jsx(T, {
          desc: COPY.updateButton
        })
      })
    })]
  });
};
export default GuidanceBanner;